import styled, { css } from 'styled-components';

import {
  blue6,
  green6,
  grey1,
  grey10,
  grey4,
  purple7,
} from 'approot/shared/styles/colours.style';
import { rem } from 'approot/shared/style';
import { fontSize20 } from 'approot/shared/styles/typography.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';

type DifferentiationProps = {
  $marginRight?: number;
  $width?: number;
  $height?: number;
  $fontSize?: number;
  $borderRadius?: number;
};

const DEFAULT_SHAPE_SIZE = 40;

const differentiationCss = css<DifferentiationProps>`
  font-size: ${({ $fontSize = fontSize20 }) => rem($fontSize)};
  line-height: ${({ $width = DEFAULT_SHAPE_SIZE }) => rem($width)};
  width: ${({ $width = DEFAULT_SHAPE_SIZE }) => rem($width)};
  height: ${({ $height = DEFAULT_SHAPE_SIZE }) => rem($height)};
  margin-right: ${({ $marginRight = 0 }) => rem($marginRight)};
  color: ${grey1};
  text-align: center;
  flex: 0 0 auto;
`;

export const GreyCircle = styled.div<DifferentiationProps>`
  ${differentiationCss}
  background-color: ${grey4};
  border-radius: 50%;
`;

export const GreenCircle = styled.div<DifferentiationProps>`
  ${differentiationCss}
  background-color: ${green6};
  border-radius: 50%;
`;

export const PurpleCircle = styled.div<DifferentiationProps>`
  ${differentiationCss}
  ${flexCentreAlignCss}

  background-color: ${purple7};
  border-radius: 50%;

  svg {
    fill: ${grey1};
  }
`;

export const BlueSquare = styled.div<DifferentiationProps>`
  ${differentiationCss}
  background-color: ${blue6};
  border-radius: ${({ $borderRadius = 4 }) => rem($borderRadius)};
`;

export const BlackDiamondWrapper = styled.div<DifferentiationProps>`
  ${differentiationCss}
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

type BlackDiamondBackgroundProps = {
  $width?: number;
  $height?: number;
  $scale?: boolean;
  $borderRadius?: number;
};

export const BlackDiamondBackground = styled.div<BlackDiamondBackgroundProps>`
  transform: rotate(45deg);
  background-color: ${grey10};
  border-radius: ${({ $borderRadius = 4 }) => rem($borderRadius)};
  /* the square root makes sure the shape's diagonal (due to the rotation) is the width passed in */
  width: ${({ $width = DEFAULT_SHAPE_SIZE, $scale }) =>
    rem($scale ? $width / Math.sqrt(2) : $width)};
  height: ${({ $height = DEFAULT_SHAPE_SIZE, $scale }) =>
    rem($scale ? $height / Math.sqrt(2) : $height)};
`;

type BlackDiamondProps = {
  $size?: number;
};

export const BlackDiamond = styled.div<BlackDiamondProps>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  line-height: ${({ $size = DEFAULT_SHAPE_SIZE }) => rem($size)};
  z-index: 1;
`;

type OrangeCrossNumberProps = {
  $size?: number;
};

export const OrangeCrossWrapper = styled.div<DifferentiationProps>`
  ${differentiationCss}
  position: relative;
  ${flexCentreAlignCss}
  svg {
    width: ${({ $width = DEFAULT_SHAPE_SIZE }) => rem($width)};
    height: ${({ $height = DEFAULT_SHAPE_SIZE }) => rem($height)};
  }
`;

export const OrangeCrossNumber = styled.div<OrangeCrossNumberProps>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  line-height: ${({ $size = DEFAULT_SHAPE_SIZE }) => rem($size)};
  z-index: 1;
  ${flexCentreAlignCss}
`;
